module.exports = __webpack_public_path__ + "img/like.a196f7a2.svg";